module.exports = __webpack_public_path__ + "img/Vector.55cc6406.png";